export default __webpack_public_path__ + "static/media/hijab.613470f2.svg";